import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurcontractKoppelen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M5 17.94 14 12l9 5.94V33H5z"
      clipRule="evenodd"
    />
    <path
      fill="#FED27A"
      d="M35 7H19v22h16zM14 25H9v8h5z"
    />
    <path
      fill="#F18700"
      d="M22 11.5v-1h10v1zm0 4v-1h10v1zm5.5 7.5h1v2.5H22v-1h5.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurcontractKoppelen);

export default ForwardRef;
